<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <p v-if="confidentialityText" v-html="confidentialityText" />
  <p v-else-if="issue">
    {{ $t(issue) }}
  </p>
</template>

<script>
  import { CguService } from "@core/services/cgu.service";

  export default {
    name: "Confidentiality",
    data() {
      return {
        confidentialityText: null,
        issue: null,
      };
    },
    created() {
      this.getConfidentiality();
    },
    methods: {
      async getConfidentiality() {
        try {
          this.$_startGlobalLoading();
          this.confidentialityText = await CguService.confidentialityText();
        } catch (error) {
          this.issue = "ERRORS.@PLEASE_TRY_AGAIN";
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      },
    },
  };
</script>
